import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../actions/authActions";
import { Moon, Sun, LogOut, User } from "lucide-react";

const ProfileMenu = ({ open, onClose, darkMode, toggleDarkMode }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  if (!open) return null;

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  return (
    <>
      <div className="fixed inset-0 z-40" onClick={onClose} />
      <div className="fixed z-50 top-16 left-3 sm:left-4">
        <div className="w-64 rounded-3xl bg-white/90 dark:bg-slate-950/80 backdrop-blur ring-1 ring-slate-200 dark:ring-slate-800 shadow-lg overflow-hidden">
          <div className="p-4 border-b border-slate-200 dark:border-slate-800 text-right">
            <div className="text-sm font-extrabold text-slate-900 dark:text-white">
              حساب کاربری
            </div>
            <div className="text-xs text-slate-500 dark:text-slate-400 mt-1">
              تنظیمات سریع
            </div>
          </div>

          <div className="p-2">
            <button
              onClick={() => {
                onClose();
                navigate("/user/profile");
              }}
              className="w-full inline-flex items-center gap-2 rounded-2xl px-3 py-2 hover:bg-slate-100 dark:hover:bg-slate-900 transition text-sm text-slate-700 dark:text-slate-200"
            >
              <User className="w-4 h-4" />
              پروفایل
            </button>

            <button
              onClick={toggleDarkMode}
              className="w-full inline-flex items-center gap-2 rounded-2xl px-3 py-2 hover:bg-slate-100 dark:hover:bg-slate-900 transition text-sm text-slate-700 dark:text-slate-200"
            >
              {darkMode ? (
                <Sun className="w-4 h-4" />
              ) : (
                <Moon className="w-4 h-4" />
              )}
              {darkMode ? "حالت روشن" : "حالت تاریک"}
            </button>

            <button
              onClick={handleLogout}
              className="w-full inline-flex items-center gap-2 rounded-2xl px-3 py-2 hover:bg-red-50 dark:hover:bg-red-900/20 transition text-sm text-red-700 dark:text-red-300"
            >
              <LogOut className="w-4 h-4" />
              خروج
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileMenu;
